import { render, staticRenderFns } from "./MessageDestination.vue?vue&type=template&id=1116e496&"
import script from "./MessageDestination.vue?vue&type=script&lang=js&"
export * from "./MessageDestination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports